// Note: filename intentionally matches import in Landingpage (`dividionAction`) to avoid breaking imports
export const DIVISIONS_LOADING = 'DIVISIONS_LOADING';
export const DIVISIONS_SUCCESS = 'DIVISIONS_SUCCESS';
export const DIVISIONS_ERROR = 'DIVISIONS_ERROR';

export const getDivisions = () => async (dispatch) => {
  dispatch({ type: DIVISIONS_LOADING });
  try {
    // Adjust endpoint as needed
    const res = await fetch('/api/divisions');
    if (!res.ok) throw new Error('Failed to fetch divisions');
    const data = await res.json();
    dispatch({ type: DIVISIONS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: DIVISIONS_ERROR, error: error.message || error });
    return [];
  }
};

export default getDivisions;
